<template>
  <div id="pallet-list-controls">
    <div class="controls">
      <div class="filter">
        <input
          class="filter-input"
          type="text"
          :placeholder="$t('pallet_list_controls.filter')"
          v-model="filterInput"
          @input="filterChanged()"
        />
      </div>
      <div class="loading">
        <v-progress-linear v-if="loading" class="palletting-progress-bar" height="30px" :indeterminate="true"></v-progress-linear>
      </div>
      <div class="show-dispatched">
        <input
          id="show-dispatched"
          class="check"
          type="checkbox"
          @input="updateDispatchedFilter($event)"
        />
        <label for="show-dispatched">{{
          $t("pallet_list_controls.show_dispatched")
        }}</label>
      </div>
      <div class="show-related">
        <input
          id="show-related"
          checked="true"
          type="checkbox"
          class="check"
          @input="toggleRelated($event)"
        />
        <label for="show-related">{{
          $t("pallet_list_controls.show_related")
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pallet-list-controls",
  props: ["filter", "pallets", "trucks"],
  data() {
    return {
      filterInput: this.filter.filter,
      isChangingFilter: false,
      timer: 0,
      checkbox: true,
      relatedLoaded: false
    };
  },
  computed:{
    loading(){
      return this.$store.getters.getLoading;
    }
  },
  watch: {
    filterInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
    },
    isChangingFilter(val) {
      if (!val) {
        this.updateFilter();
      }
    },
    pallets() {
      if (!this.relatedLoaded) {
        this.$emit("filterUpdated", this.filterInput + this.getRelated());
        this.relatedLoaded = true;
      }
    },
    trucks() {
      if (!this.relatedLoaded) {
        this.$emit("filterUpdated", this.filterInput + this.getRelated());
        this.relatedLoaded = true;
      }
    }
  },
  async mounted() {
    this.getDispatched();
  },
  methods: {
    getDispatched() {
      if (localStorage.getItem("showDispatched") === "true") {
        const showDispatched = document.getElementById("show-dispatched");
        showDispatched.checked = true;
        this.$emit("filterDispatchedChanged", true);
      }
    },

    filterChanged() {
      if (this.filterInput == "") {
        this.$router.push({ name: "pallet-planning" });
      } else {
        this.$router.replace({
          name: "pallet-planning",
          params: { filter: this.filterInput }
        });
      }
      this.isChangingFilter = true;
    },

    updateFilter() {
      this.$emit("filterUpdated", this.filterInput);
    },
    updateDispatchedFilter(event) {
      localStorage.setItem("showDispatched", event.target.checked);
      this.$emit("filterDispatchedChanged", event.target.checked);
    },
    createNewPallet() {
      this.$emit("openNewPallet");
    },
    toggleRelated(event) {
      if (event.target.checked) {
        this.related = this.getRelated();
      } else {
        this.related = "";
      }
      this.$emit("filterUpdated", this.filterInput + this.related);
    },

    getRelated() {
      const relatedOrders = [];
      const showingOrders = [];
      //get already showing orders
      const selectedParts = this.filterInput.split(",");
      //remove white spaces
      selectedParts.forEach(filter => {
        showingOrders.push(filter.trim());
      });
      //search for related orders in trucks and pallets
      this.trucks.forEach(truck => {
        if (truck.orders) {
          const truckOrders = truck.orders.split(",");
          truckOrders.forEach(truckOrder => {
            if (
              !relatedOrders.includes(truckOrder.trim()) &&
              !showingOrders.includes(truckOrder.trim())
            ) {
              relatedOrders.push(truckOrder.trim());
            }
          });
        }
      });
      this.pallets.forEach(pallet => {
        if (pallet.order_number) {
          const palletOrders = pallet.order_number.split(",");
          palletOrders.forEach(palletOrder => {
            if (
              !relatedOrders.includes(palletOrder.trim()) &&
              !showingOrders.includes(palletOrder.trim())
            ) {
              relatedOrders.push(palletOrder.trim());
            }
          });
        }
      });
      let relatedOrdersString = "";
      relatedOrders.forEach((order, i) => {
        if (i == 0) relatedOrdersString += ", ";
        relatedOrdersString += order;
        if (relatedOrders.length > 0 && i < relatedOrders.length - 1)
          relatedOrdersString += ", ";
      });
      return relatedOrdersString;
    }
  }
};
</script>

<style scoped>
.controls {
  position: relative;
}
.filter {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: calc(100% - 400px);
}
.filter-input {
  width: 100%;
  height: 30px;
}
.show-dispatched {
  position: absolute;
  top: 0;
  margin-left: 10px;
  left: calc(100% - 400px);
  z-index: 2;
  font-weight: 800;
}
.show-related {
  position: absolute;
  top: 0;
  margin-left: 10px;
  left: calc(100% - 200px);
  z-index: 2;
  font-weight: 800;
}
.loading{
  z-index: -1;
}
.hidden{
  display: none;
}
.palletting-progress-bar{
  position: absolute;
  top: -14px;
  width: 100%;
}
</style>
